import { render, staticRenderFns } from "./ProductTourTooltip.vue?vue&type=template&id=0d2d06b8"
import script from "./ProductTourTooltip.vue?vue&type=script&lang=js"
export * from "./ProductTourTooltip.vue?vue&type=script&lang=js"
import style0 from "./ProductTourTooltip.vue?vue&type=style&index=0&id=0d2d06b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports